module.exports = "/assets/e8b2827064998be89028b88a25162fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5F.png
// module id = 1057
// module chunks = 0